<template>
  <v-dialog
    v-model="visible"
    :width="this.props.width || 360"
    :persistent="this.props.persistent ? this.props.persistent : false"
    dark
    :key="key"
    @click:outside="retransmitClickOutside">
    <v-card class="player-modal player-message-modal">
      <div class="dialog-container" :style="this.props.style">
        <p class="success-dialog">{{ message }}</p>
        <slot></slot>
        <!-- <div v-if="this.props.content"> -->
        <component
          :is="this.props.content"
          @prompt-rejected="dismiss"></component>
        <!-- </div> -->
        <v-card-actions>
          <v-btn
            v-if="this.props.cancelable"
            class="red"
            dark
            rounded
            @click="handleCancelClick">
            Cancel
          </v-btn>
          <v-btn
            v-if="!this.props.customActions"
            class="green"
            dark
            rounded
            @click="handleOKClick">
            OK
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PopUpDialog",
  props: ["props"],
  data() {
    return {
      key: false,
      visible: this.props?.visible ?? false,
    }
  },
  computed: {
    message() {
      if (this.props.message === false) {
        return
      }
      return this.props?.message || "Success!\nLook in your inbox"
    },
    // visible: {
    //   get() {
    //     return this.props?.visible ?? false
    //   },
    //   set(val) {
    //     this.$store.state[`${this.props.visiblePropName}`] = val
    //   },
    // },
  },
  methods: {
    handleOKClick() {
      this.visible = false
      this.key = !this.key
      this.$emit("prompt-accepted", true)
    },
    handleCancelClick() {
      this.visible = false
      // this.key = !this.key
      this.$emit("prompt-rejected", false)
    },
    dismiss() {
      this.key = !this.key
      this.visible = false
    },
    retransmitClickOutside() {
      this.$emit("click:outside")
    },
  },
}
</script>

<style lang="sass">
@import '@/assets/sass/_variables.sass'
.v-dialog
  border-radius: $dialog-border-radius !important
  background-color: #333d46
.dialog-container
  display: flex
  flex-direction: column
  align-items: center
  background-color: #333d46

.success-dialog
  padding: 1rem 2rem
  white-space: pre-line
  text-align: center
  &::first-line
    color: $brightest-green
    font-size: 1.3rem
</style>
